<template>
  <div id="test_ueditor">
    <!-- 测试试题编辑器 -->
    <div id="test_echart">
      <Ueditor @ready="editorReady" />
    </div>
    <div class="but" @click="fuzhi">赋值</div>
    <div class="but" @click="makesure">确定</div>
    <div class="con" v-html="content"></div>
  </div>
</template>

<script>
import Ueditor from "@/components/Ueditor";
export default {
  components: {
    Ueditor,
  },
  data() {
    return {
      myCharts: "",
      richEditor: {
        dialogVisible: false,
        object: {
          id: null,
          questionType: 4,
          gradeLevel: null,
          subjectId: null,
          title: "",
          items: [],
          analyze: "",
          correct: "",
          score: "",
          difficult: 0,
        },
        parameterName: "title",
        instance: null,
      },
      content:
        '<img class="kfformula" src="data:image/png;base64,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" data-latex="x=\frac {-bpm sqrt {{b}^{2}-4ac}} {2a}"/><br/><span class="gapfilling-span b755c09d-a47a-4544-91bd-756d3bf92283">1</span><span class="gapfilling-span a66d66e9-8817-4104-9283-4a0d54ae488d">2</span><span class="gapfilling-span 44b382ee-2463-4970-adba-cd3c6bd832bc">3</span>',
    };
  },
  methods: {
    editorReady(instance) {
      this.richEditor.instance = instance;
      let currentContent = this.richEditor.object[
        this.richEditor.parameterName
      ];
      this.richEditor.instance.setContent(currentContent);
      // 光标定位到Ueditor
      this.richEditor.instance.focus(true);
    },
    makesure() {
      let content = this.richEditor.instance.getContent();
      this.content = content;
      console.log(content);
    },
    /**
     * 判断当前编辑器中是否有填空题选项
     */
    questionItemReset(content) {
      let spanRegex = new RegExp(
        '<span class="gapfilling-span(.*?)">(.*?)<\\/span>',
        "g"
      );
      let _this = this;
      let newFormItem = [];
      let gapfillingItems = content.match(spanRegex);
      if (gapfillingItems === null) {
        this.$message.error("请插入填空");
        return false;
      }
      gapfillingItems.forEach(function (span, index) {
        let pairRegex = /<span class="gapfilling-span(.*?)">(.*?)<\/span>/;
        pairRegex.test(span);
        newFormItem.push({
          id: null,
          itemUuid: RegExp.$1,
          prefix: RegExp.$2,
          content: "",
          score: "0",
        });
      });

      newFormItem.forEach(function (item) {
        _this.form.items.some((oldItem, index) => {
          if (oldItem.itemUuid === item.itemUuid) {
            item.content = oldItem.content;
            item.id = oldItem.id;
            item.score = oldItem.score;
            return true;
          }
        });
      });
      _this.form.items = newFormItem;
      return true;
    },
    fuzhi() {
      this.richEditor.instance.setContent(this.content);
      // 光标定位到Ueditor
      this.richEditor.instance.focus(true);
    },
  },
  mounted() {
    // this.showCharts();
  },
};
</script>

<style lang="less" scoped>
#test_ueditor {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  #test_echart {
    width: 1000px;
    height: 900px;
    // background-color: @baseColor;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .gapfilling-span {
    /* background-color: antiquewhite; */
    display: inline-block;
    /* text-decoration: underline; */
    border-bottom: 1px solid #444;
    padding: 0 30px;
    margin: 0 5px;
  }
}
</style>